import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import Questions from '../../Common/Questions';
import questionsEn from '../../questions_en.json';
import questionsZh from '../../questions_zh.json';
import { RootMenu, SubMenu } from '../../types';

interface Props {
  menuData?: RootMenu[];
}

const Accordion: FC<Props> = ({ menuData }) => {
  const { i18n } = useTranslation('resources');
  const router = useRouter();

  const questions = i18n.language === 'zh' ? questionsZh : questionsEn;
  const path = router.asPath.split('?')[0];
  let menus: SubMenu[] = [];
  menuData?.forEach((item) => {
    menus = [...menus, ...item.subMenu];
  });
  const { data, describeBottom, describeBottomTitle } = menus?.find?.(({ value }) => path.includes(`/${value}/`)) || {};
  const dynamicQuestion = {
    title: { question: describeBottomTitle, answer: describeBottom },
    questionsAnswers: i18n.language === 'zh' ? data?.faqListCn : data?.faqListEn,
  };
  const question: any = describeBottom ? dynamicQuestion : questions?.[path as keyof typeof questions];

  if (!question) {
    return null;
  }

  return <Questions title={question.title} questionsAnswers={question.questionsAnswers} className="mt-[80px]" />;
};

export default Accordion;
